export default "__VITE_ASSET__U16tkMTR__"